<div class="my-5">
  <!-- page-header -->
  <sm-page-header [breadcrumb]="breadcrumb" title="settings.refType.title" description="settings.refType.description">
  </sm-page-header>
  <!-- content -->
  <div class="content">
    <sm-data-table-builder [dataTableObject]="dataTableObject" [datas]="data" [loading]="loading"></sm-data-table-builder>
  </div>
  <sm-drawer #drawer [drawer]="refTypeDrawer"></sm-drawer>
  <sm-dialog #dialog [dialog]="refTypeDialog"></sm-dialog>
</div>
